/**
 * Checkout CTA for KL24 peek cart drawers (Singles + Lückenfüller).
 */
(function () {
  const CART_MIN_ORDER_CENTS = Number(window.kl24ShippingRules?.minOrderCents) || 500;
  const CART_COUNTRY = String(window.kl24ShippingRules?.countryIso || 'DE').toUpperCase();
  const CART_FREE_SHIPPING_CENTS =
    CART_COUNTRY === 'AT'
      ? Number(window.kl24ShippingRules?.freeShippingFromCentsAt) || 5900
      : Number(window.kl24ShippingRules?.freeShippingFromCentsDe) ||
        Number(window.kl24ShippingRules?.freeShippingFromCents) ||
        3900;
  const MIN_MARKER_PCT = Math.floor((CART_MIN_ORDER_CENTS * 100) / CART_FREE_SHIPPING_CENTS);

  const formatEuro = (cents) => {
    const fmt = window.formatMoneyDE || window.Kl24EuroFormat?.formatMoneyDE;
    if (fmt) return fmt(cents);
    const value = Math.max(0, Number(cents) || 0) / 100;
    const amount = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
    return `${amount}\u00A0€`;
  };

  const shippingGatesMarkup = () => {
    return `
    <div class="tcg-gap-cart-drawer__shipping-gates">
      <div class="cart-shipping-gates cart-progress-panel" data-peek-cart-gates>
        <div class="cart-progress-panel__inner">
          <p class="cart-progress-panel__status" data-cart-progress-status></p>
          <div class="cart-progress-panel__track-wrap">
            <div class="cart-progress-panel__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
              <div class="cart-progress-panel__fill" style="width:0%;" data-free-shipping-progress="0"></div>
              <span class="cart-progress-panel__marker cart-progress-panel__marker--min" style="left:${MIN_MARKER_PCT}%;"></span>
              <span class="cart-progress-panel__marker cart-progress-panel__marker--free"></span>
            </div>
            <div class="cart-progress-panel__scale" aria-hidden="true" style="--kl24-min-marker-pct:${MIN_MARKER_PCT}%;">
              <span class="cart-progress-panel__amount" data-cart-progress-current></span>
              <span class="cart-progress-panel__marker-label cart-progress-panel__marker-label--min" data-cart-progress-min></span>
              <span class="cart-progress-panel__amount cart-progress-panel__amount--goal" data-cart-progress-goal></span>
            </div>
          </div>
          <a class="cart-progress-panel__fill-rest" data-cart-fill-rest href="/pages/auffuellen" hidden>
            Rest automatisch auffüllen
          </a>
        </div>
      </div>
    </div>
  `;
  };

  const CHECKOUT_BTN_CLASS =
    'tcg-gap-filler__panel-btn tcg-gap-filler__panel-btn--primary tcg-gap-cart-drawer__checkout-btn';

  const normalizeFooterButtons = (footer) => {
    const checkout = footer.querySelector('[data-kl24-cart-checkout]');
    if (checkout) {
      checkout.classList.remove('button', 'button--primary', 'button--secondary');
      CHECKOUT_BTN_CLASS.split(' ').forEach((cls) => checkout.classList.add(cls));
    }
    footer.querySelectorAll('[data-singles-cart-close], [data-gap-cart-close]').forEach((btn) => {
      if (!btn.classList.contains('tcg-gap-cart-drawer__close')) {
        btn.classList.remove('button--secondary', 'tcg-gap-cart-drawer__close-btn--ghost');
        btn.classList.add(
          'button',
          'tcg-gap-filler__panel-btn',
          'tcg-gap-filler__panel-btn--ghost',
          'tcg-gap-cart-drawer__close-btn'
        );
      }
    });
  };

  const ensureFooterChrome = (drawerRoot) => {
    if (!drawerRoot) return;
    const footer = drawerRoot.querySelector('.tcg-gap-cart-drawer__footer');
    if (!footer) return;

    if (!footer.querySelector('[data-peek-cart-gates]')) {
      const gates = document.createElement('div');
      gates.innerHTML = shippingGatesMarkup();
      footer.insertBefore(gates.firstElementChild, footer.firstChild);
    }

    if (!footer.querySelector('[data-kl24-cart-checkout]')) {
      const checkout = document.createElement('a');
      checkout.href = '/checkout';
      checkout.className = CHECKOUT_BTN_CLASS;
      checkout.dataset.kl24CartCheckout = '';
      checkout.dataset.cartCheckoutButton = '';
      checkout.textContent = 'Zur Kasse';
      const closeBtn = footer.querySelector('[data-singles-cart-close], [data-gap-cart-close]');
      if (closeBtn) {
        footer.insertBefore(checkout, closeBtn);
      } else {
        footer.append(checkout);
      }
    }

    normalizeFooterButtons(footer);
  };

  const bind = (drawerRoot) => {
    ensureFooterChrome(drawerRoot);
    const btn = drawerRoot?.querySelector('[data-kl24-cart-checkout]');
    if (!btn || btn.dataset.kl24CheckoutBound === '1') return;
    btn.dataset.kl24CheckoutBound = '1';
    btn.addEventListener('click', (event) => {
      if (btn.classList.contains('is-disabled') || btn.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
      }
    });
  };

  const sync = (drawerRoot, cart) => {
    if (!drawerRoot) return;
    bind(drawerRoot);

    const checkoutBtn = drawerRoot.querySelector('[data-kl24-cart-checkout]');
    if (!checkoutBtn) return;

    const subtotal = Number(cart?.items_subtotal_price) || 0;
    const itemCount = Number(cart?.item_count) || 0;
    const belowMinimum = itemCount > 0 && subtotal < CART_MIN_ORDER_CENTS;
    const disabled = itemCount === 0 || belowMinimum;

    checkoutBtn.classList.toggle('is-disabled', disabled);
    checkoutBtn.classList.toggle('cart__checkout-button--need-more', belowMinimum);
    checkoutBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    if (belowMinimum) {
      const left = Math.max(0, CART_MIN_ORDER_CENTS - subtotal);
      const tpl =
        window.kl24CartStrings?.checkoutButtonMinimum ||
        'Noch {{ amount }} bis Mindestbestellwert (5 €)';
      checkoutBtn.textContent = tpl.replace('{{ amount }}', formatEuro(left));
      checkoutBtn.tabIndex = -1;
    } else if (disabled) {
      checkoutBtn.textContent = 'Zur Kasse';
      checkoutBtn.tabIndex = -1;
    } else {
      checkoutBtn.textContent = 'Jetzt zur Kasse';
      checkoutBtn.removeAttribute('tabindex');
    }

    const gatesRoot = drawerRoot.querySelector('[data-peek-cart-gates]');
    if (gatesRoot) {
      gatesRoot.hidden = itemCount === 0;
    }
  };

  const syncAll = (cart) => {
    document
      .querySelectorAll('[data-gap-cart-drawer], [data-singles-cart-drawer], .tcg-gap-cart-drawer')
      .forEach((drawer) => sync(drawer, cart));
  };

  window.Kl24CartDrawerCheckout = {
    sync,
    syncAll,
    bind,
    CART_MIN_ORDER_CENTS,
    CART_FREE_SHIPPING_CENTS,
    formatEuro,
  };
})();
